import Page from 'src/components/page/page';
import useShopkeepersDetails from './shopkeeper-details.hook';
import { Box, Container } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import CNLoading from 'src/components/loading-cn/CNLoading';
import ShopkeeperForm from './components/shopkeeper-form';

export default function ShopkeeperDetails() {
  const { isEdit, isSubmitting, methods, STATUS_OPTIONS, isLoadingShopkeeperDetails, onSubmit } =
    useShopkeepersDetails();

  return (
    <Page title={isEdit ? 'Editar Lojista' : 'Cadastrar Lojista'}>
      <Container maxWidth="lg">
        <HeaderBreadcrumbs heading={isEdit ? 'Editar Lojista' : 'Cadastrar Lojista'} links={[]} />
        {isLoadingShopkeeperDetails ? (
          <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center" mt={30}>
            <CNLoading />
          </Box>
        ) : (
          <ShopkeeperForm
            methods={methods}
            onSubmit={onSubmit}
            STATUS_OPTIONS={STATUS_OPTIONS}
            isEdit={isEdit}
            isSubmitting={isSubmitting}
          />
        )}
      </Container>
    </Page>
  );
}
